import { Component } from '@angular/core';
import { HeaderComponent } from '../../../shared/header/header.component';
import { UserService } from '../../../../services/user/user.service';
import { LocalStorageService } from '../../../../services/local-storage/local-storage.service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ComputerDTO } from '../../../../interfaces/computer-dto';
import { ModalComponent } from '../../../shared/modal/modal.component';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

@Component({
  selector: 'app-computer-settings',
  standalone: true,
  imports: [HeaderComponent, CommonModule, ModalComponent],
  templateUrl: './computer-settings.component.html',
  styleUrl: './computer-settings.component.scss'
})
export class ComputerSettingsComponent {

  constructor(
    private userService: UserService,
    private localStorageService: LocalStorageService,
    private router: Router
  ) { }

  computers: ComputerDTO[] = [];
  unit!: number;
  percentTicketWindow: number = 0;

  isEditing = false;
  computerId!: number;

  selectedServiceType!: string;
  selectedManualCall!: boolean;

  isModalOpen = false;
  modalTitle!: string;
  modalMessage!: string;

  isModalErrorOpen: boolean = false;
  modalErrorTitle: string = '';
  modalErrorMessage: string = '';

  ngOnInit() {
    this.unit = Number(this.localStorageService.get("currentUnit"));
    this.loadTicketWindow();
    this.getTicketWindowPercent(Number(this.unit));
  }

  onChangeTypeOfService(event: Event, computer: ComputerDTO) {
    const serviceType = event.target as HTMLSelectElement;
    computer.registeredQueue = Number(serviceType.value);
  }

  onChangeManualCall(event: Event, computer: ComputerDTO) {
    const manualCall = event.target as HTMLSelectElement;
    computer.manualCall = manualCall.value === 'true';
  }

  editTicketWindown(computer: any) {
    computer.isEditing = !computer.isEditing;
  }

  async setConfiguration(computer: any) {
    this.userService.setQueueToComputer(computer.id, Number(this.unit), computer.registeredQueue, computer.name)
      .then(() => {
        this.isModalOpen = true;
        this.modalTitle = 'Alteração da fila realizada com sucesso!';
        this.modalMessage = 'Peça ao operador do guichê alterado para sair e entrar novamente no sistema. Assim, as novas permissões serão aplicadas corretamente.';
        computer.isEditing = false;
      }).catch((ex: HttpErrorResponse) => {
        this.isModalErrorOpen = true;
        this.modalErrorTitle = 'Ops! Não foi possível alterar a chamada';
        this.modalErrorMessage = ex.error.detail;
        computer.isEditing = true;
      });
    this.userService.setManualCall(computer.manualCall, Number(this.unit), computer.id, computer.name)
      .then(() => {
        this.isModalOpen = true;
        this.modalTitle = 'Alteração realizada com sucesso!';
        this.modalMessage = 'Peça ao operador do guichê alterado para sair e entrar novamente no sistema. Assim, as novas permissões serão aplicadas corretamente.';
        computer.isEditing = false;
      }).catch((ex: HttpErrorResponse) => {
        this.isModalErrorOpen = true;
        this.modalErrorTitle = 'Ops! Não foi possível alterar a chamada';
        this.modalErrorMessage = ex.error.detail;
        computer.isEditing = true;
      });
  }

  async loadTicketWindow() {
    try {
      const response = await (await this.userService.getTicketsWindows(String(this.unit))).toPromise();
      this.computers = response.data;
    } catch (error) {
      console.error('Erro ao carregar guichês:', error);
      // Trate o erro conforme necessário
    }
  }

  getTicketWindowPercent(clinicId: number) {
    this.userService.getTicketWindowPercent(clinicId)
      .then((res) => this.percentTicketWindow = res);
  }

  backToDashboard() {
    this.router.navigate(['/home']);
  }

  closeModal() {
    this.isModalOpen = false;
  }

  closeErrorModal() {
    this.isModalErrorOpen = false;
  }
}
